import React from 'react';

class ProgressBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: props.progress,
      step: 0,
    };
    window.setProgress = this.setProgress.bind(this);
  }

  setProgress(n, m) {
    const { progress } = this.props;
    this.setState(Object.assign(
      { step: n },
      m !== undefined ? { progress: m } : {},
    ));
  }

  render({ }, { progress, step }) {
    const doc = document.documentElement;
    const viewWidth = doc.clientWidth;
    const progressPercent = parseInt(step * 100 / progress);
    const minLeftPercent = 60 * 100 / viewWidth;
    const maxLeftPercent = (viewWidth - 60) * 100 / viewWidth;
    let leftPos = null;
    if (progressPercent < minLeftPercent)
      leftPos = `calc(${minLeftPercent}% - 60px)`;
    else if (progressPercent < maxLeftPercent)
      leftPos = `calc(${progressPercent}% - 60px)`;
    else
      leftPos = `calc(${maxLeftPercent}% - 60px)`; 

    return ( typeof progress === 'number' &&
      <div
        id="hu-bot-progress-bar"
        data-step={`${ progress === step ? 'last' : step }`}
      >
        <style>{
`#hu-bot-progress-bar::after { width: ${progressPercent}%; }
.progress-bar-label { left: ${leftPos}; }`
        }</style>
        <div className="progress-bar-label hu-color_dark">
          <svg width="10px" height="3px" viewBox="0 0 10 3" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Group-Copy" transform="translate(-71.000000, -89.000000)" fill="#0A4359">
                <path d="M68,91.6612983 L71.0318827,91.6612983 C72.3951688,91.6612983 73.6919908,91.0723536 74.5890805,90.0458162 L74.6525451,89.9731938 C75.2675982,89.2693902 76.3367428,89.1974437 77.0405464,89.8124967 C77.1213362,89.8830988 77.195229,89.9612236 77.2612271,90.0458162 L77.2612271,90.0458162 C78.0566243,91.0653113 79.2775215,91.6612983 80.5705904,91.6612983 Z" id="Rectangle-4"></path>
              </g>
            </g>
          </svg>
          { progress === step ?
            <span>Done! 🎉</span>
            :
            <span><b className="hu-color_accent">{ progress - step } </b>{ progress - step === 1 ? 'step' : 'steps' } to finish</span>
          }
        </div>
      </div>
    );
  }
}

export default ProgressBar;


// WEBPACK FOOTER //
// ./app/js/components/progress-bar/ProgressBar.js